import { TransparentButton } from 'common/button'
import Icon from 'icon'
import { useRouter } from 'next/router'
import Link from 'next/link'

function LearningPlanMenu() {
  const { asPath } = useRouter()
  const isProjectsPlan = asPath === '/aprender/proyectos'

  return (
    <menu className="menu">
      <ul>
        <li>
          <Link href="/aprender" className={!isProjectsPlan ? 'active' : null}>
            <Icon size={24} name="learning-path" color={!isProjectsPlan ? '#FFD02E' : 'var(--neutral)'} />
            <TransparentButton className="link">
              Plan de estudios
            </TransparentButton>
          </Link>
        </li>
        <li>
          <Link href="/aprender/proyectos" className={isProjectsPlan ? 'active' : null}>
            <Icon size={24} name="projects" color={isProjectsPlan ? 'var(--turquoise)' : 'var(--neutral)'} />
            <TransparentButton className="link">
              Proyectos
            </TransparentButton>
          </Link>
        </li>
      </ul>
    </menu>
  )
}

export default LearningPlanMenu
